import type { CaseSummary, Dimension, Lens } from './types';

export const LENSES: Lens[] = [
  'Conocimiento',
  'Proceso',
  'Métricas',
  'Automatización',
  'Adopción'
];

export const PERSONAS: string[] = [
  'FinOps Practitioner',
  'Engineering',
  'Finance',
  'Product',
  'Procurement',
  'Leadership',
  'ITAM (IT Asset Management)',
  'ITFM (IT Financial Management)',
  'Sustainability',
  'ITSM (IT Service Management)',
  'Security'
];

// Real FinOps Framework 2026 structure from the source workbook (22 capabilities).
export const DIMENSIONS: Dimension[] = [
  {
    id: 'understand',
    name: 'Understand Usage & Cost',
    enabled: true,
    capabilities: ['Data Ingestion', 'Allocation', 'Anomaly Management', 'Reporting & Analytics']
  },
  {
    id: 'quantify',
    name: 'Quantify Business Value',
    enabled: true,
    capabilities: [
      'Planning & Estimating',
      'Forecasting',
      'Budgeting',
      'KPIs & Benchmarking',
      'Unit Economics'
    ]
  },
  {
    id: 'optimize',
    name: 'Optimize Usage & Cost',
    enabled: false,
    capabilities: [
      'Architecting & Workload Placement',
      'Rate Optimization',
      'Usage Optimization',
      'Licensing & SaaS',
      'Sustainability'
    ]
  },
  {
    id: 'manage',
    name: 'Manage FinOps Practice',
    enabled: false,
    capabilities: [
      'FinOps Practice Operations',
      'FinOps Assessment',
      'FinOps Education & Enablement',
      'Governance, Policy & Risk',
      'Executive Strategy Alignment',
      'Automation, Tools & Services',
      'Invoicing & Chargeback',
      'Intersecting Disciplines'
    ]
  }
];

export function findDimensionByCapability(capability: string): Dimension | undefined {
  return DIMENSIONS.find((d) => d.capabilities.includes(capability));
}

export const CASES: CaseSummary[] = [
  {
    caseId: 'CASE-2026-0001',
    name: 'Banco Andino 2026',
    client: 'Banco Andino',
    country: 'Chile',
    state: 'In Progress',
    updatedAt: '2026-08-13'
  },
  {
    caseId: 'CASE-2026-0002',
    name: 'Retail Global FinOps',
    client: 'Retail Global',
    country: 'México',
    state: 'Draft',
    updatedAt: '2026-08-11'
  }
];
